// @ts-nocheck
import { storeService } from '@/services';
export default {
    setStoreManagementGoodsPriceSurchargeInfosDialogOpen({ commit }, isOpen = true) {
        commit('SET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS_DIALOG_OPEN', isOpen);
    },
    setStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen({ commit }, isOpen = true) {
        commit('SET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS_ADD_SURCHARGE_SECTION_OPEN', isOpen);
    },
    setSelectedStoreId({ commit }, storeId = '') {
        commit('SET_SELECTED_STORE_ID', storeId);
    },
    setEditSurchargeItem({ commit }, item = {}) {
        commit('SET_EDIT_SURCHARGE_ITEM', item);
    },
    // 상점 할증 설정 (C,R,U,D)
    /**
     * 상점 할증 설정 생성
     */
    async postStoreManagementGoodsPriceSurchargeInfos({ commit }, payload) {
        const { storeId } = payload;
        const response = await storeService.postStoreGoodsPriceSurchargeInfos({
            storeId,
            payload,
        });
        commit('POST_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS', response.data);
        commit('PUBLISH_GOODS_PRICE_SURCHARGE_INFOS_HAS_BEEN_CHANGED', response.data);
    },
    /**
     * 상점 할증 설정 조회
     */
    async getStoreManagementGoodsPriceSurchargeInfos({ commit }, storeId) {
        const response = await storeService.getStoreGoodsPriceSurchargeInfos({
            storeId,
        });
        commit('GET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS', response.data);
    },
    /**
     * 상점 할증 설정 수정
     */
    async putStoreManagementGoodsPriceSurchargeInfos({ commit }, payload = {}) {
        const { storeId, surchargeId } = payload;
        const response = await storeService.putStoreGoodsPriceSurchargeInfos({
            storeId,
            surchargeId,
            payload,
        });
        commit('PUT_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS', response.data);
    },
    /**
     * 상점 할증 설정 삭제
     */
    async deleteStoreManagementGoodsPriceSurchargeInfos({ state, commit }, payload = {}) {
        const { storeId, surchargeId } = payload;
        const response = await storeService.deleteStoreGoodsPriceSurchargeInfos({
            storeId,
            surchargeId,
        });
        if (!response.data.isSuccess) {
            return;
        }
        const updatedFeeList = state.storeManagementGoodsPriceSurchargeInfosList
            .filter((surcharge) => surcharge.id !== surchargeId);
        commit('DELETE_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS', updatedFeeList);
        commit('PUBLISH_GOODS_PRICE_SURCHARGE_INFOS_HAS_BEEN_CHANGED', updatedFeeList);
    },
    // 초기화
    clearStoreManagementGoodsPriceSurchargeInfos({ commit }) {
        commit('CLEAR_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS');
    },
};
